/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Col_SkillInputs */

const en_mk_model_col_skill = /** @type {(inputs: Mk_Model_Col_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

const id_mk_model_col_skill = /** @type {(inputs: Mk_Model_Col_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill`)
};

/**
* | output |
* | --- |
* | "Skill" |
*
* @param {Mk_Model_Col_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_col_skill = /** @type {((inputs?: Mk_Model_Col_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Col_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_col_skill(inputs)
	return en_mk_model_col_skill(inputs)
});